/* eslint-disable */

//tslint:disable

import { IHttpApi, IHttpApiFetchConfig } from '@cian/http-api/shared/http';
import {
  TDesktopDeleteAllNotificationsModel,
  IDesktopDeleteAllNotificationsRequest,
  IMappers,
  IDesktopDeleteAllNotificationsResponse,
  IDesktopDeleteAllNotificationsResponseError,
  TDesktopDeleteAllNotificationsResponse,
} from './types';

const defaultConfig: TDesktopDeleteAllNotificationsModel = {
  apiType: 'public',
  assertStatusCodes: [400, 200, 204],
  method: 'POST',
  microserviceName: 'notification-center',
  pathApi: '/v1/desktop/delete-all-notifications/',
  hostType: 'api',
} as TDesktopDeleteAllNotificationsModel;

function createDesktopDeleteAllNotificationsModel(
  parameters: IDesktopDeleteAllNotificationsRequest,
): TDesktopDeleteAllNotificationsModel {
  return {
    ...defaultConfig,
    parameters,
  };
}

export interface IDesktopDeleteAllNotificationsOptions<TResponse400, TResponse200, TResponse204> {
  httpApi: IHttpApi;
  parameters: IDesktopDeleteAllNotificationsRequest;
  config?: IHttpApiFetchConfig;
  mappers?: IMappers<TResponse400, TResponse200, TResponse204>;
}

async function fetchDesktopDeleteAllNotifications<TResponse400, TResponse200, TResponse204>({
  httpApi,
  parameters,
  config,
  mappers,
}: IDesktopDeleteAllNotificationsOptions<TResponse400, TResponse200, TResponse204>): Promise<
  TResponse400 | TResponse200 | TResponse204 | TDesktopDeleteAllNotificationsResponse
> {
  const { response, statusCode } = await httpApi.fetch(createDesktopDeleteAllNotificationsModel(parameters), config);

  if (mappers && statusCode in mappers) {
    if (statusCode === 400) {
      return mappers[400](response as IDesktopDeleteAllNotificationsResponseError);
    }

    if (statusCode === 200) {
      return mappers[200](response as IDesktopDeleteAllNotificationsResponse);
    }

    if (statusCode === 204) {
      return mappers[204]();
    }
  }

  return { response, statusCode } as TDesktopDeleteAllNotificationsResponse;
}

export { defaultConfig, createDesktopDeleteAllNotificationsModel, fetchDesktopDeleteAllNotifications };
